import { Reducer, Subscription, Effect } from 'umi'

export interface AppModelState {}
export interface AppType {
  namespace: 'App'
  state: AppModelState
  effects: {
    setNavBarTitle: Effect
  }
  reducers: {
    setData: Reducer<AppModelState>
  }
  subscriptions?: { setup: Subscription }
}
const AppModel: AppType = {
  namespace: 'App',
  state: {
    navBarTitle: '标题',
  },
  effects: {
    setNavBarTitle({ payload }, { call, put }) {
      put({ type: 'setNavBarTitle', payload })
    },
  },
  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },
}
export default AppModel
